import {Component} from '@angular/core';
import {InlineActionAbstract} from './inline-action.abstract';

@Component({
  selector: 'a[maiaInlineAction]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./inline-action.component.scss'],
})
export class InlineActionLinkComponent extends InlineActionAbstract {}
